import { Component, Input } from '@angular/core';
import { CommentResponse } from '../../models/question.model';
import { QuestionService } from '../../services/question.service';
import { CommonModule } from '@angular/common';
import { FormsModule, NgModel } from '@angular/forms';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-comments',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './comments.component.html',
  styleUrl: './comments.component.scss'
})
export class CommentsComponent {
   @Input() questionCode: string | undefined;
   @Input() questionID!: number;

   comments: CommentResponse[] = [];
   newComment: string = '';
   userId = 0;
   isLoading: boolean = true;

  constructor(private questionService: QuestionService) {}

  ngOnInit() {
    this.loadComments();
    const storedId = localStorage.getItem('id');
    this.userId = storedId ? parseInt(storedId, 10) : 0;
  }

  loadComments() {
    this.questionService.getComments(this.questionID).subscribe(
      (data) => {
        // Sort the comments by created_at in descending order
        this.comments = data.sort((a, b) => {
          const dateA = a.created_at ? new Date(a.created_at).getTime() : 0; 
          const dateB = b.created_at ? new Date(b.created_at).getTime() : 0; 
  
          return dateB - dateA; 
        });
        this.isLoading = false;
      },
      (error) => {
        console.error('Erro ao carregar os comentários:', error);
        this.isLoading = false;
      }
    );
  }
  

  submitComment() {
    if (!this.newComment.trim()) {
      return;
    }
  
    this.isLoading = true; 
    this.questionService.postComment(this.questionID, this.newComment).subscribe(
      (response) => {
        this.loadComments();
        this.newComment = ''; 
        this.isLoading = false; 
      },
      (error) => {
        console.error('Error submitting comment:', error);
        this.isLoading = false; 
      }
    );
  }

  deleteComment(commentId: number) {
    this.questionService.deleteComment(commentId).subscribe(
      (response) => {
        Swal.fire({
                    text: 'Comentário Removido!',
                    icon: 'success',
                    toast: true,
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 4000,
                    timerProgressBar: true
                  });
        this.loadComments(); 
      },
      (error) => {
           Swal.fire({
                    text: 'Alguma coisa deu errado...',
                    icon: 'error',
                    toast: true,
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 4000,
                    timerProgressBar: true
                  });
      }
    );
  }
}
